import React from 'react';
import ActionMenu from '../../../shared/components/ui/ActionMenu.jsx';
import FileExplorerEntryIcon from './FileExplorerEntryIcon.jsx';

// Sin controles de paginación: alto fijo (misma dimensión que ocupa
// FileExplorerTable) con scroll propio. El backend igual pagina por pedido
// aunque no se le pidan controles — ver handleLoadMoreGrid en
// FileExplorerScreen — así que si hay más, se ofrece "Cargar más" en el footer.
const FileExplorerGrid = ({
  entries,
  loading,
  onRowClick,
  totalItems,
  hasMore,
  loadingMore,
  onLoadMore,
  selectable = false,
  selectedIds = null,
  onToggleEntry,
  getEntryActions
}) => {
  const showEmptyState = !loading && entries.length === 0;

  return (
    <div className="rounded-xl md:bg-surface md:shadow-lg md:border md:border-line md:overflow-hidden flex flex-col">
      <div className="h-[460px] overflow-y-auto">
        {showEmptyState ? (
          <div className="text-center py-8 text-content-muted text-sm">No hay archivos todavía</div>
        ) : (
          <div
            className={`grid grid-cols-[repeat(auto-fill,minmax(110px,1fr))] gap-4 p-5 ${loading ? 'blur-[1px]' : ''}`.trim()}
          >
            {entries.map((entry) => {
              const isSelected = selectable && (selectedIds?.has(entry.id) || false);

              return (
                <div
                  key={entry.id}
                  // En modo selección togglea; fuera de ese modo las carpetas
                  // navegan y los archivos abren el visor (ver handleEntryRowClick).
                  className={`relative flex flex-col items-center gap-2 rounded-lg p-3 text-center min-w-0 transition-colors cursor-pointer select-none hover:bg-surface-2 ${
                    isSelected ? 'ring-2 ring-amber bg-amber-hover/10' : ''
                  }`}
                  onClick={() => onRowClick(entry)}
                >
                  {selectable && (
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onClick={(event) => event.stopPropagation()}
                      onChange={() => onToggleEntry(entry)}
                      className="absolute top-2 left-2 h-4 w-4 rounded border-line bg-surface text-amber focus:ring-amber focus:ring-offset-0 cursor-pointer"
                    />
                  )}
                  {!selectable && (
                    // El menú se renderiza en un portal, pero los eventos de
                    // React igual burbujean hasta la tarjeta: se cortan acá
                    // para que elegir una opción no dispare también onRowClick.
                    <div className="absolute top-1 right-1" onClick={(event) => event.stopPropagation()}>
                      <ActionMenu options={getEntryActions(entry)} />
                    </div>
                  )}
                  <div className="flex items-center justify-center w-14 h-14 rounded-lg bg-bg">
                    <FileExplorerEntryIcon entry={entry} size={30} />
                  </div>
                  <span
                    className={`text-sm leading-tight break-words line-clamp-2 ${
                      entry.type === 'folder' ? 'text-content font-medium' : 'text-content'
                    }`}
                  >
                    {entry.name}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="px-3 py-3 md:px-4 bg-table-head border-t border-line flex flex-wrap items-center justify-between gap-3 text-sm text-content">
        <div>
          Total: <span className="font-medium">{totalItems}</span>
        </div>
        {hasMore && (
          <button
            type="button"
            onClick={onLoadMore}
            disabled={loadingMore}
            className="rounded-md bg-surface-2 px-3 py-1.5 text-content transition-colors hover:bg-line disabled:cursor-not-allowed disabled:opacity-50"
          >
            {loadingMore ? 'Cargando...' : 'Cargar más'}
          </button>
        )}
      </div>
    </div>
  );
};

export default FileExplorerGrid;
